import { useCallback, useEffect, useState } from "react";

import { ApiError } from "src/core/apiError";
import { Brig } from "src/gen/rest/brig/BrigService";
import { GetUsersRequest, UsersResponse } from "src/gen/schema/brig/bapi";
import { User as Bot } from "src/gen/schema/models/user";

import { BOTS_PROVIDER } from "../../constants";

/**
 * Custom hook to fetch and manage bot user data
 * Uses the User model directly from API response
 */
export const useBotData = () => {
  const [bots, setBots] = useState<Bot[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<ApiError | undefined>(undefined);

  const fetchBots = useCallback(() => {
    setLoading(true);
    setError(undefined);
    Brig.getUsers(GetUsersRequest.create({ provider: BOTS_PROVIDER }))
      .then((response: UsersResponse) => {
        setBots(response.users || []);
      })
      .catch(setError)
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchBots();
  }, [fetchBots]);

  return {
    bots,
    loading,
    botError: error,
    refetchBots: fetchBots
  };
};
